declare var saveAs: any;

module EEX.McEc.Controls.CertificateDialog {

    // ReSharper disable once InconsistentNaming
    export interface SetPrivateKeyPasswordAttribute extends CertificateDialogBaseAttribute {
        privateKeyPassword: string,
        privateKeyPasswordRepeated: string,
    }

    export class SetPrivateKeyPasswordModel extends CertificateDialogBaseModel<SetPrivateKeyPasswordAttribute> {

        constructor(model: CertificateDialogModel, processStep: number) {
            super(model, processStep);

            this.on("change:privateKeyPassword", this.updateDialogModel);
            this.on("change:privateKeyPasswordRepeated", this.updateDialogModel);
        }

        public updateDialogModel() {
            let password = this.get().privateKeyPassword;
            let repeatedPassword = this.get().privateKeyPasswordRepeated;
            if (this.arePasswordsValidAndEquals(password, repeatedPassword)) {
                this.model.set({ privateKeyPassword: password });
                this.canContinue();
            } else {
                this.canNotContinue();
            }
        }

        private arePasswordsValidAndEquals(password: string, repeatedPassword): boolean {
            return password !== undefined && repeatedPassword !== undefined && password !== "" && password === repeatedPassword && password.length >= (settings.MinimalPasswordLength ? settings.MinimalPasswordLength : true) && Helper.isComplex(password);
        }

    }

    // ReSharper disable once InconsistentNaming
    export interface SetPrivateKeyPasswordOptions extends CertificateDialogBaseOptions {
    }

    export class SetPrivateKeyPasswordView extends CertificateDialogBaseView<SetPrivateKeyPasswordModel> {
        model: SetPrivateKeyPasswordModel;
        passwordComplexity: number = settings.PasswordComplexity;

        private containers: {
            form: HTMLElement,
        }

        private elements: {
            passwordInput: JQuery,
            repeatedPasswordInput: JQuery,
            passwordField: JQuery,
            repeatedPasswordField: JQuery,
        }

        constructor(model: SetPrivateKeyPasswordModel, target: HTMLElement, options?: SetPrivateKeyPasswordOptions) {
            super(model,
                target,
                Templates.CertificateDialog_SetPrivateKeyPassword,
                AppKitchen.OptionsHelper.merge(options,
                    {
                        title: Strings.CertificateDialog_SetPrivateKeyPassword_Title
                    }));
        }

        render() {
            super.render();
            this.setContainers();
            this.renderFields();
            this.setElements();
            this.setEvents();

            this.model.updateDialogModel();
            return this;
        }

        private setContainers(): void {
            this.containers = {
                form: this.$el.find(".set-private-key-password-form-container")[0]
            }
        }

        private renderFields(): void {
            const from = $('<div class="a-form"/>');
            const table = $('<table/>');
            const passwordField = AppKitchen.UIHelper.renderTemplate(Templates.PasswordFormField,
                {
                    id: "password",
                    label: Strings.CertificateDialog_Password,
                    placeholder: Strings.CertificateDialog_Password,
                });

            const repeatPasswordField = AppKitchen.UIHelper.renderTemplate(Templates.PasswordFormField,
                {
                    id: "repeatPassword",
                    label: Strings.CertificateDialog_RepeatPassword,
                    placeholder: Strings.CertificateDialog_RepeatPassword
                });

            $(passwordField).appendTo(table);
            $(repeatPasswordField).appendTo(table);
            table.appendTo(from);
            from.appendTo(this.containers.form);
        }

        private setElements(): void {
            this.elements = {
                passwordInput: this.$el.find("#password input"),
                repeatedPasswordInput: this.$el.find("#repeatPassword input"),
                passwordField: this.$el.find("#password"),
                repeatedPasswordField: this.$el.find("#repeatPassword"),
            }
        }

        private setEvents(): void {

            this.elements.passwordInput.password({
                shortPass: Strings.PasswordComplexity_shortPass,
                badPass: "",    // Strings.PasswordComplexity_badPass,
                goodPass: "",   // Strings.PasswordComplexity_goodPass,
                strongPass: "", // Strings.PasswordComplexity_strongPass,
                enterPass: "",  // Strings.PasswordComplexity_enterPass,
                notComplex: Strings.PasswordComplexity_notComplex,
                animate: true,
                showPercent: false,
                animateSpeed: 'fast',
                requiresComplexPassword: settings.PasswordComplexity,
                minimumLength: settings.MinimalPasswordLength ? settings.MinimalPasswordLength : 0
            });

            this.elements.passwordInput.focusout(() => this.updatePasswordInModel());
            this.elements.repeatedPasswordInput.focusout(() => {
                this.updatePasswordInModel();
                this.validatePasswords();
            });

            this.elements.passwordInput.focusin(() => {
                this.clearValueFromElement(this.elements.repeatedPasswordInput);
                this.clearMessage(this.elements.repeatedPasswordField);
            });
            this.elements.repeatedPasswordInput.focusin(() => this.clearMessage(this.elements.repeatedPasswordField));

            this.elements.passwordInput.focus();
        }

        private clearValueFromElement(element: JQuery): void {
            element.val('');
        }

        private validatePasswords(): void {
            const password = this.getPasswordFromElement();
            const repeatedPassword = this.getRepeatedPasswordFromElement();
            if (password !== repeatedPassword) {
                this.showMessage(this.elements.repeatedPasswordField, Strings.CertificateDialog_CreatePrivateKey_ErrorPasswordsNotSame, "invalid");
            }
        }

        private updatePasswordInModel(): void {
            const password = this.getPasswordFromElement();
            const repeatedPassword = this.getRepeatedPasswordFromElement();
            this.model.set({
                privateKeyPassword: password,
                privateKeyPasswordRepeated: repeatedPassword
            });
        }

        private getPasswordFromElement(): string {
            return this.getStringFromInput(this.elements.passwordInput);
        }

        private getRepeatedPasswordFromElement(): string {
            return this.getStringFromInput(this.elements.repeatedPasswordInput);
        }

        private getStringFromInput(element: JQuery): string {
            const value = element.val();
            return value as string;
        }

        private clearMessage(element: JQuery): void {
            element.removeClass("mandatory");
            element.removeClass("warning");
            element.removeClass("invalid");
            element.find(".a-input-error-message .a-message").html("");
        }

        private showMessage(element: JQuery, message: string, messageClass: "mandatory" | "warning" | "invalid"): void {
            this.clearMessage(element);
            element.addClass(messageClass);
            element.find(".a-input-error-message .a-message").html(message);
        }
    }
}